import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Loader2, Mail, ArrowRight } from "lucide-react";
import { log } from "../../utils/logger";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const LEAD_CAPTURED_KEY = "lead_checklist_captured";

export default function LeadCaptureForm({ source, compact = false, onSuccess }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/leads`, {
        email: email.trim(),
        name: name.trim() || null,
        source,
        origin_url: window.location.origin,
      });
      localStorage.setItem(LEAD_CAPTURED_KEY, "1");
      onSuccess?.(data);
      navigate("/checklist-thanks", { state: { email: email.trim(), download_url: data.download_url } });
      return;
    } catch (err) {
      log.warn("lead capture failed", err);
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Please enter a valid email address.");
    }
    setLoading(false);
  };

  return (
    <form onSubmit={submit} data-testid={`lead-form-${source}`} className={compact ? "space-y-2" : "space-y-3"}>
      {!compact && (
        <input
          data-testid={`lead-name-${source}`}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="First name (optional)"
          maxLength={80}
          className="w-full rounded-xl border-2 border-[var(--c-border)] bg-[var(--c-bg)] px-4 py-3 text-sm text-[var(--c-text)] outline-none placeholder:text-[var(--c-muted)] focus:border-[#1E3A8A]"
        />
      )}
      <div className="flex flex-col gap-2 sm:flex-row">
        <div className="relative flex-1">
          <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[var(--c-muted)]" />
          <input
            data-testid={`lead-email-${source}`}
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="w-full rounded-xl border-2 border-[var(--c-border)] bg-[var(--c-bg)] py-3 pl-10 pr-4 text-sm text-[var(--c-text)] outline-none placeholder:text-[var(--c-muted)] focus:border-[#1E3A8A]"
          />
        </div>
        <button
          type="submit"
          data-testid={`lead-submit-${source}`}
          disabled={loading || !email.trim()}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl border-2 border-[var(--c-border)] bg-[#C8102E] px-5 py-3 text-sm font-bold text-white shadow-[3px_3px_0px_var(--c-shadow)] transition-transform hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ArrowRight className="h-4 w-4" />}
          {loading ? "Sending…" : "Send me the checklist"}
        </button>
      </div>
      {error && <p data-testid={`lead-error-${source}`} className="text-xs font-semibold text-red-600">{error}</p>}
      <p className="text-[11px] text-[var(--c-muted)]">Free PDF. No spam — unsubscribe anytime.</p>
    </form>
  );
}
